import React, { useMemo } from 'react'

import { useAtomValue } from 'jotai'
import { useSelectedTrial } from 'src/features/auth/context'

import { VisibilityModalComponent } from './visibility-modal-component'
import { templateDetailAtom } from '../../atom'
import { TrialHospitalsByUid } from '../../trial-hospitals-by-uid'

type Props = {
  onClose: () => void
  onOpenVisibilitySetModalFactory: (smallItemUid: string) => () => void
  onOpenVisibilityBulkSetModal: () => void
}

export const VisibilityModalContainer: React.FC<Props> = props => {
  const {
    onClose,
    onOpenVisibilitySetModalFactory,
    onOpenVisibilityBulkSetModal,
  } = props
  const template = useAtomValue(templateDetailAtom)
  const { selectedTrial } = useSelectedTrial()
  const trialHospitalsByUid = useMemo<TrialHospitalsByUid>(
    () => Object.fromEntries(selectedTrial.trialHospitals.map(h => [h.uid, h])),
    [selectedTrial.trialHospitals],
  )

  return (
    <VisibilityModalComponent
      mediumItems={template.mediumItems}
      templateTitle={template.title}
      trialHospitalsByUid={trialHospitalsByUid}
      templateStatus={template.originalTemplate?.status}
      onClose={onClose}
      onOpenVisibilitySetModalFactory={onOpenVisibilitySetModalFactory}
      onOpenVisibilityBulkSetModal={onOpenVisibilityBulkSetModal}
    ></VisibilityModalComponent>
  )
}
